import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Form } from '../_forms';
import { AlertService, ResolveSettingsService } from '../_services';
import { MFAType, ResolvePreviewTab, ResolveSettings, ResolveSettingsMissingMessage } from '../_models';

@Component({
  selector: 'app-resolve-settings',
  templateUrl: './resolve-settings.component.html',
  styleUrls: ['./resolve-settings.component.scss'],
})
export class ResolveSettingsComponent extends Form implements OnInit {
  mfaTypes = MFAType;
  settings: ResolveSettings;
  isSaving = false;
  previewTabs = ResolvePreviewTab;
  activePreviewTab = ResolvePreviewTab.DigitalReceipt;

  constructor(
    protected router: Router,
    protected location: Location,
    protected alertService: AlertService,
    private formBuilder: FormBuilder,
    private resolveSettingsService: ResolveSettingsService
  ) {
    super(alertService, router, location);
  }

  ngOnInit() {
    this.resolveSettingsService
      .getAccountDefaultSettings()
      .pipe(takeUntil(this.destroy$))
      .subscribe((settings) => {
        if (settings) {
          this.settings = settings;
          this.buildForm(settings);
        } else {
          this.alertService.error(ResolveSettingsMissingMessage);
        }
      });
  }

  setPreviewTab(tab: ResolvePreviewTab) {
    this.activePreviewTab = tab;
  }

  isMfaEnabled(): boolean {
    return this.getControlValue('mfa_type') !== this.mfaTypes.Disabled;
  }

  toggleMfaEnabled() {
    if (this.isMfaEnabled()) {
      this.getControl('mfa_type').patchValue(this.mfaTypes.Disabled);
    } else {
      this.getControl('mfa_type').patchValue(this.mfaTypes.BestAvailable);
    }
  }

  save() {
    this.submitted = true;

    if (this.settings) {
      this.isSaving = true;
      const payload = {
        show_view_order: this.isBooleanFieldChecked('view_order_enabled'),
        show_buy_again: this.isBooleanFieldChecked('buy_again_enabled'),
        show_request_refund: this.isBooleanFieldChecked('request_refund_enabled'),
        mfa_type: this.getControlValue('mfa_type'),
      };

      this.resolveSettingsService
        .patch(this.settings.id, payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response: ResolveSettings) => {
            this.settings = response;
            this.buildForm(response);
            this.alertService.success('Digital receipt settings saved successfully', true);
            this.isSaving = false;
          },
          (error) => {
            this.handleSubmitError(error, false, true);
            this.isSaving = false;
          }
        );
    }
  }

  private buildForm(settings: ResolveSettings) {
    this.setForm(
      this.formBuilder.group({
        view_order_enabled: [settings.show_view_order],
        buy_again_enabled: [settings.show_buy_again],
        request_refund_enabled: [settings.show_request_refund],
        mfa_type: [settings.mfa_type],
      })
    );
  }
}
